import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";

export function Logo({ variant = "dark", className = "" }) {
  const { logoUrl } = useBranding();
  const isLight = variant === "light";

  if (logoUrl) {
    return (
      <Link
        to="/"
        className={`flex items-center ${className}`}
        data-testid="logo-link"
        aria-label="JK House Cleaning home"
      >
        <span className={isLight ? "rounded-xl bg-white/95 px-3 py-2 shadow-sm inline-flex" : "inline-flex"}>
          <img
            src={logoUrl}
            alt="JK House Cleaning"
            className="h-11 sm:h-12 w-auto object-contain"
            data-testid="brand-logo-img"
          />
        </span>
      </Link>
    );
  }

  return (
    <Link
      to="/"
      className={`flex items-center gap-2.5 group ${className}`}
      data-testid="logo-link"
      aria-label="JK House Cleaning home"
    >
      <span
        className={`grid place-items-center w-10 h-10 rounded-xl transition-transform duration-200 group-hover:scale-105 ${
          isLight ? "bg-white/15 backdrop-blur" : "bg-navy"
        }`}
      >
        <Sparkles className={`w-5 h-5 ${isLight ? "text-white" : "text-brandgreen"}`} strokeWidth={2} />
      </span>
      <span className="leading-none">
        <span className={`block font-heading font-extrabold text-lg tracking-tight ${isLight ? "text-white" : "text-navy"}`}>
          JK House
        </span>
        <span className={`block font-heading text-[10px] mt-1 font-semibold tracking-[0.28em] uppercase ${isLight ? "text-brandgreen-light" : "text-brandgreen"}`}>
          Cleaning
        </span>
      </span>
    </Link>
  );
}
